import { APICore } from './apiCore';

const api = new APICore();

interface TempleDetails {
    name: string;
    slug?: string;
    shortSummary: string;
    description: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    state: string;
    country?: string;
    pincode: string;
    latitude: number;
    longitude: number;
    contactPhone: string;
    contactEmail?: string;
    websiteUrl?: string;
    mainDeity: string;
    otherDeities?: string[];
    templeType?: string;
    establishedYear?: number;
    timings?: Record<string, any>;
    thumbnailUrl?: string;
    bannerUrl?: string;
    registrationStatus?: string;
    registrationNumber?: string;
    isVerified?: boolean;
}

interface DashboardParams {
    startDate?: string;
    endDate?: string;
}

// Super Admin Dashboard
export const getAdminDashboard = (params?: DashboardParams) => {
    return api.get('/temple-analytics/admin/dashboard', params);
};

// Temple Admin Dashboard
export const getTempleDashboard = (
    templeId: number,
    params?: DashboardParams
) => {
    return api.get(`/temple-analytics/temple/${templeId}/dashboard`, params);
};

// Get all temples with pagination and filtering
export const getTemples = (params: { limit: number; page: number; sortType?: string; city?: string; state?: string; registrationStatus?: string, templeType?: string; }) => {
    const baseUrl = '/temples';
    return api.get(`${baseUrl}`, params);
};

// Register a new temple
export const addTemple = (params: TempleDetails) => {
    const baseUrl = '/temples/register';
    return api.create(`${baseUrl}`, params);
};

// Get temple details by ID
export const getTempleDetails = (params: { templeId: number }) => {
    const baseUrl = `/temples/${params.templeId}`;
    return api.get(`${baseUrl}`, '');
};

// Update temple details
export const updateTempleDetails = (params: any) => {
    const { id, templeId, ...body } = params;
    const idToUse = id ?? templeId;
    if (!idToUse) throw new Error('Missing temple id for update');
    const baseUrl = `/temples/${idToUse}`;
    return api.updatePatch(`${baseUrl}`, body);
};

// Delete temple by ID
export const deleteTempleByIdApi = (templeId: number) => {
    const baseUrl = `/temples/${templeId}`;
    return api.delete(baseUrl);
};

// Verify temple (admin only)
export const verifyTemple = (templeId: number, data: { registrationStatus: string; verifiedBy?: number }) => {
    const baseUrl = `/temples/${templeId}/verify`;
    return api.updatePatch(baseUrl, data);
};

// Add media to temple
export const addTempleMedia = (templeId: number, media: { url: string; mediaType: string; title?: string; description?: string; isPrimary?: boolean }) => {
    const baseUrl = `/temples/${templeId}/media`;
    return api.create(baseUrl, media);
};

// Add facility to temple
export const addTempleFacility = (templeId: number, facility: { name: string; description?: string; isAvailable?: boolean }) => {
    const baseUrl = `/temples/${templeId}/facilities`;
    return api.create(baseUrl, facility);
};

// Get temple approval requests
export const getApprovalRequests = (params?: {
    status?: string;
    templeId?: number;
}) => {
    const baseUrl = '/temples/approval-requests';
    return api.get(baseUrl, params);
};

// Update temple approval request
export const updateApprovalRequest = (
    requestId: number,
    data: {
        status: 'APPROVED' | 'REJECTED';
        remarks?: string;
    }
) => {
    const baseUrl = `/temples/approval-requests/${requestId}`;
    return api.updatePatch(baseUrl, data);
};